import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectInstruments = (state: RootState) =>
  sortBy(state.instruments.instruments, 'name');

export const selectActiveInstruments = (state: RootState) =>
  sortBy(
    state.instruments.instruments.filter(x => x.active),
    'name'
  );
export const selectInstrumentErrors = (state: RootState) =>
  state.instruments.errors;
